var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rowNewSection"},[(_vm.isEdit)?_c('RowSectionForm',{staticClass:"rowNewSection-form",attrs:{"data":_vm.data},on:{"submit":_vm.submit}}):_c('div',{staticClass:"rowNewSection-holder",on:{"click":_vm.add}},[_c('div',{staticClass:"rowNewSection-icon"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }